import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ConfigService } from './auth/config.service';

export interface Notification {
  id: number;
  message: string;
  read: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  constructor(private http: HttpClient, 
          private configService: ConfigService){}

  getNotifications(flag:number,RoleId:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetNotifications?flag=${flag}&RoleId=${RoleId}`;
          return this.http.get<any>(apiUrl).pipe(
            map((response) => {
              return response;
            }),
            catchError((err) => {
              return throwError(() => new Error('Notification data retrieval failed.'));
            })
          );
  }
  updateNotification(notifyId:number,RoleId:any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/UpdateNotification?notifyId=${notifyId}&RoleId=${RoleId}`;
          return this.http.get<any>(apiUrl).pipe(
            map((response) => {
              return response;
            }),
            catchError((err) => {
              return throwError(() => new Error('Notification data retrieval failed.'));
            })
          );
  }
}